import React, { Component } from "react";
import { profile, GET, PUT, alert, loading } from "./CustomComponent.js";
import { Navbar, Nav, Container, NavDropdown } from "react-bootstrap";
import { Sidebar, Menu, MenuItem } from "react-pro-sidebar";
import { Link } from "react-router-dom";
import LOGO from "../assets/images/logo.png";
import "../assets/css/bootstrap.css";
export default class NavbarComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dropdown: "",
      array_link: [],
      user_profile: profile,
    };
  }

  icon = (io) => <span className="icon">{io}</span>;

  componentDidMount = async () => {};
  componentMenu = () => {
    return (
      <div>
        <div>
          <a className="btn btn-outline-primary rounded-0 px-3 border-0 w-100 text-start" style={{ paddingTop: 12, paddingBottom: 12 }} href="/">
            หน้าหลัก
          </a>
        </div>
        <div>
          <a className="btn btn-outline-primary rounded-0 px-3 border-0 w-100 text-start" style={{ paddingTop: 12, paddingBottom: 12 }} href="/about">
            เกี่ยวกับเรา
          </a>
        </div>
        <div>
          <a className="btn btn-outline-primary rounded-0 px-3 border-0 w-100 text-start" style={{ paddingTop: 12, paddingBottom: 12 }} href="/service">
            บริการ
          </a>
        </div>
        <div>
          <a className="btn btn-outline-primary rounded-0 px-3 border-0 w-100 text-start" style={{ paddingTop: 12, paddingBottom: 12 }} href="/work">
            ผลงาน
          </a>
        </div>
        <div>
          <a className="btn btn-outline-primary rounded-0 px-3 border-0 w-100 text-start" style={{ paddingTop: 12, paddingBottom: 12 }} href="/contact">
            ติดต่อเรา
          </a>
        </div>
      </div>
    );
  };

  render() {
    const { user_profile, dropdown, array_link } = this.state;
    return (
      <div className="hpx-50">
        <Navbar className="py-0 bg-light position-fixed w-100" style={{ zIndex: 1000 }} expand="xl">
          <div className="container px-3 px-xl-4">
            <Navbar.Brand href="/dashboard" className="fw-bold text-dark">
              <div className="position-relative">
                <img
                  alt="logo"
                  src={LOGO}
                  height={30}
                  style={{ objectFit: "contain" }}
                  className="pointer"
                  onClick={() => {
                    window.location.href = "/dashboard";
                  }}
                />
              </div>
            </Navbar.Brand>
            <Navbar.Toggle className="border-0" aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav" className="overflow-auto">
              <Nav className="ms-auto py-0">
                <div className="d-none d-xl-flex align-items-center px-3">
                  <a className="btn btn-outline-primary rounded-0 px-3 border-0" style={{ paddingTop: 12, paddingBottom: 12 }} href="/">
                    หน้าหลัก
                  </a>
                  <a className="btn btn-outline-primary rounded-0 px-3 border-0" style={{ paddingTop: 12, paddingBottom: 12 }} href="/about">
                    เกี่ยวกับเรา
                  </a>
                  <a className="btn btn-outline-primary rounded-0 px-3 border-0" style={{ paddingTop: 12, paddingBottom: 12 }} href="/service">
                    บริการ
                  </a>
                  <a className="btn btn-outline-primary rounded-0 px-3 border-0" style={{ paddingTop: 12, paddingBottom: 12 }} href="/work">
                    ผลงาน
                  </a>
                  <a className="btn btn-outline-primary rounded-0 px-3 border-0" style={{ paddingTop: 12, paddingBottom: 12 }} href="/contact">
                    ติดต่อเรา
                  </a>
                </div>
                <div className="d-block d-xl-none mb-5 pt-4" style={{ height: "80vh" }}>
                  {this.componentMenu()}
                </div>
              </Nav>
            </Navbar.Collapse>
          </div>
        </Navbar>
      </div>
    );
  }
}
